/*
 * ChairMates Fit Finder + Shoe Fit (Chivari)
 * Mounted by snippets/chairmates-fit-finder.liquid and snippets/chairmates-shoe-fit.liquid.
 * Chair sizes come from the chair product metafields custom.cm_ball_front / custom.cm_ball_back
 * (read through templates/product.cmfit.liquid). Only whole numbers 25-32 count as verified.
 */
(function () {
  'use strict';
  if (window.ChairMates) return;

  var SIZES = [25, 26, 27, 28, 29, 30, 31, 32];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function validSize(v) {
    v = v == null ? '' : String(v).trim();
    if (!/^\d{2}$/.test(v)) return null;
    var n = +v;
    return n >= 25 && n <= 32 ? n : null;
  }
  function money(cents, fmt) {
    if (cents == null || isNaN(cents)) return '';
    var amt = cents / 100;
    var withCommas = function (s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withCommas(String(Math.round(amt)));
      if (k === 'amount_with_comma_separator') return amt.toFixed(2).replace('.', ',');
      var p = amt.toFixed(2).split('.');
      return withCommas(p[0]) + '.' + p[1];
    });
  }
  function readData(root) {
    var s = root.querySelector('script[data-cm-data]');
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  // keep keyboard focus and caret position across re-renders
  function keepFocus(root, fn) {
    var a = document.activeElement, key = null, start = null, end = null;
    if (a && root.contains(a) && a.getAttribute('data-cm-focus')) {
      key = a.getAttribute('data-cm-focus');
      try { start = a.selectionStart; end = a.selectionEnd; } catch (e) {}
    }
    fn();
    if (key) {
      var n = root.querySelector('[data-cm-focus="' + key + '"]');
      if (n) { n.focus(); try { if (start != null) n.setSelectionRange(start, end); } catch (e) {} }
    }
  }
  function addToCart(cfg, items) {
    return fetch(cfg.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j && (j.description || j.message) || 'Could not add to cart.');
        return j;
      });
    });
  }
  // same as the Titan Stage / Bar builders: refresh the theme cart, then open its slide-out drawer
  function openCartDrawer(cfg) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    setTimeout(function () {
      var cb = document.querySelector('modal-open[target="cart-drawer"]');
      if (cb) cb.click(); else document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    }, 600);
  }
  function byKey(list, key, val) { for (var i = 0; i < (list || []).length; i++) if (list[i][key] === val) return list[i]; return null; }
  function ballFor(cfg, size) { return byKey(cfg.balls, 'size', size); }
  function isUsable(p) { return !!(p && p.ok && p.id && p.available); }

  // what a set of chairs needs: 1 Chair Shoe 4-pack per chair; 1 Ball Insert 4-pack per chair for each size
  function setLines(cfg, front, back, colorKey, qty) {
    var lines = [], problems = [];
    var shoe = colorKey ? byKey(cfg.shoes, 'key', colorKey) : null;
    if (shoe) {
      lines.push({ product: shoe, qty: qty, name: 'Chair Shoes · ' + shoe.name + ' · 4-pack', note: '1 pack per chair' });
      if (!isUsable(shoe)) problems.push('The ' + shoe.name + ' Chair Shoe isn\u2019t available right now.');
    }
    if (front != null && back != null) {
      if (front === back) {
        var b1 = ballFor(cfg, front);
        lines.push({ product: b1, qty: qty, name: 'Ball Inserts · ' + front + ' mm · 4-pack', note: 'All 4 legs · 1 pack per chair' });
        if (!isUsable(b1)) problems.push('The ' + front + ' mm Ball Insert isn\u2019t available right now.');
      } else {
        // each chair uses 2 front + 2 back, so one 4-pack of each size covers 2 chairs
        var packs = Math.ceil(qty / 2);
        var spare = qty % 2 === 1 ? ' · includes 2 spares' : '';
        [[front, 'Front legs'], [back, 'Back legs']].forEach(function (pr) {
          var b2 = ballFor(cfg, pr[0]);
          lines.push({ product: b2, qty: packs, name: 'Ball Inserts · ' + pr[0] + ' mm · 4-pack', note: pr[1] + ' · 1 pack covers 2 chairs' + spare });
          if (!isUsable(b2)) problems.push('The ' + pr[0] + ' mm Ball Insert isn\u2019t available right now.');
        });
      }
    }
    return { lines: lines, problems: problems };
  }
  function linesTotal(lines) {
    var t = 0, ok = true;
    lines.forEach(function (l) { if (l.product && l.product.price != null && l.qty) t += l.product.price * l.qty; else if (l.qty) ok = false; });
    return ok ? t : null;
  }
  function summaryHTML(cfg, lines, head) {
    var h = '<div class="cm-summary">' + (head || '');
    lines.forEach(function (l) {
      var price = l.product && l.product.price != null && l.qty ? money(l.product.price * l.qty, cfg.moneyFormat) : '';
      h += '<div class="cm-line"><span class="cm-line__name"><strong>' + esc(l.name) + '</strong>' + (l.note ? '<small>' + esc(l.note) + '</small>' : '') + '</span>' +
        '<span class="cm-line__qty">' + (l.qty ? '× ' + l.qty : '—') + (price ? '<small>' + esc(price) + '</small>' : '') + '</span></div>';
    });
    var tot = linesTotal(lines);
    var any = lines.some(function (l) { return l.qty; });
    h += '<div class="cm-total"><span>Total</span><span>' + (tot != null && any ? esc(money(tot, cfg.moneyFormat)) : '—') + '</span></div></div>';
    return h;
  }
  function swatchesHTML(cfg, selected, act) {
    var h = '<div class="cm-swatches" role="radiogroup" aria-label="Chair Shoe color">';
    cfg.shoes.forEach(function (s) {
      if (!s.ok) return;
      var on = selected === s.key, dis = !s.available;
      h += '<button type="button" class="cm-swatch' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-act="' + act + '" data-v="' + esc(s.key) + '"' + (dis ? ' disabled' : '') +
        ' title="' + esc(s.name + (dis ? ' (sold out)' : '')) + '"><span class="cm-swatch__chip" style="background:' + esc(s.hex) + '"></span><span class="cm-swatch__name">' + esc(s.name) + (dis ? '<small>Sold out</small>' : '') + '</span></button>';
    });
    return h + '</div>';
  }
  function qtyHTML(qty, id) {
    return '<div class="cm-qty"><button type="button" class="cm-step" data-act="qty" data-d="-1" aria-label="Fewer chairs">−</button>' +
      '<label class="cm-sr" for="' + id + '">Number of chairs</label>' +
      '<input id="' + id + '" class="cm-qty__input" type="number" inputmode="numeric" min="0" step="1" placeholder="0" value="' + (qty || '') + '" data-cm-focus="qty" data-input="qty">' +
      '<button type="button" class="cm-step" data-act="qty" data-d="1" aria-label="More chairs">+</button><span class="cm-muted">chairs</span></div>';
  }
  function itemsFrom(lines, props) {
    var out = [];
    lines.forEach(function (l) {
      if (!l.product || !l.product.id || !(l.qty > 0)) return;
      var it = { id: l.product.id, quantity: l.qty };
      if (props) it.properties = props;
      out.push(it);
    });
    return out;
  }

  /* ---------------- Fit Finder (ChairMates product pages) ---------------- */
  function mountFitFinder(root) {
    var cfg = readData(root); if (!cfg) return;
    var ui = root.querySelector('[data-cm-ui]'); var uid = 'cmff' + Math.random().toString(36).slice(2, 7);
    var st = { mode: 'set', path: null, query: '', results: [], searching: false, searchMsg: '', sel: null, mf: '', mb: '', sure: false, color: null, qty: 0, pShoe: {}, pBall: {}, busy: false, err: '' };
    var seq = 0, timer = null;

    function fit() {
      if (st.path === 'chair' && st.sel && st.sel.verified) return { front: st.sel.front, back: st.sel.back, source: 'Verified fit · ' + st.sel.title, chair: st.sel };
      if (st.path === 'manual' && st.sure && validSize(st.mf) && validSize(st.mb)) return { front: +st.mf, back: +st.mb, source: 'Your sizes (not verified by Chivari)', chair: null };
      return null;
    }
    function showFitment() { return st.path === 'unsure' || (st.path === 'chair' && st.sel && !st.sel.verified); }

    function render() { keepFocus(root, function () { ui.innerHTML = html(); }); }
    function html() {
      var h = '<div class="cm-modes" role="group" aria-label="What are you buying?">' +
        modeBtn('set', 'Outfit my chairs', 'Chair Shoes + Ball Inserts sized to your chairs') +
        modeBtn('parts', 'Replacement parts', 'Chair Shoes or Ball Inserts on their own') + '</div>';
      h += st.mode === 'set' ? setHTML() : partsHTML();
      if (st.err) h += '<p class="cm-error" role="alert">' + esc(st.err) + '</p>';
      return h;
    }
    function modeBtn(v, label, sub) {
      var on = st.mode === v;
      return '<button type="button" class="cm-mode' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="mode" data-v="' + v + '"><strong>' + label + '</strong><span>' + sub + '</span></button>';
    }
    function dot(n, done) { return '<span class="cm-dot' + (done ? ' is-done' : '') + '" aria-hidden="true">' + (done ? '✓' : n) + '</span>'; }
    function setHTML() {
      var f = fit(), fm = showFitment();
      var h = '<section class="cm-card"><h3 class="cm-h">' + dot(1, !!f) + 'Find my fit</h3><div class="cm-tabs" role="group" aria-label="How should we size your Ball Inserts?">' +
        tab('chair', 'My Chivari chair') + tab('manual', 'I know my sizes') + tab('unsure', 'Not sure') + '</div>';
      if (!st.path) h += '<p class="cm-muted">Choose how we should size your Ball Inserts.</p>';
      if (st.path === 'chair') h += chairHTML();
      if (st.path === 'manual') h += manualHTML();
      if (st.path === 'unsure') h += '<p>No problem. Start with the <strong>Fitment Pack</strong>: test the Ball Insert sizes on your chair legs, find the snug fit, then come back and order with your sizes.</p>';
      h += '</section>';
      if (fm) return h + fitmentHTML();
      var shoe = st.color ? byKey(cfg.shoes, 'key', st.color) : null;
      h += '<section class="cm-card"><h3 class="cm-h">' + dot(2, !!shoe) + 'Chair Shoe color' + (shoe ? '<span class="cm-h__val"> · ' + esc(shoe.name) + '</span>' : '') + '</h3>' +
        swatchesHTML(cfg, st.color, 'color') + '<p class="cm-muted">Ball Inserts are always clear.</p></section>';
      h += '<section class="cm-card"><h3 class="cm-h">' + dot(3, st.qty > 0) + 'How many chairs?</h3>' + qtyHTML(st.qty, uid + '-qty') + '</section>';
      var calc = setLines(cfg, f ? f.front : null, f ? f.back : null, st.color, st.qty);
      var head = f ? '<p class="cm-fit"><small>' + esc(f.source) + '</small><strong>Front ' + f.front + ' mm · Back ' + f.back + ' mm</strong></p>' : '';
      var lines = calc.lines.slice();
      if (!shoe) lines.unshift({ product: null, qty: 0, name: 'Chair Shoes · choose a color · 4-pack', note: '1 pack per chair' });
      if (!f) lines.push({ product: null, qty: 0, name: 'Ball Inserts · size from step 1', note: '' });
      var missing = [];
      if (!f) missing.push(st.path === 'manual' ? 'your leg sizes (and confirm them)' : 'your chair fit');
      if (!shoe) missing.push('a Chair Shoe color');
      if (!st.qty) missing.push('how many chairs');
      var locked = missing.length > 0 || calc.problems.length > 0 || st.busy;
      h += summaryHTML(cfg, lines, head);
      h += '<button type="button" class="cm-atc" data-act="add-set"' + (locked ? ' disabled aria-disabled="true"' : '') + '>' + (st.busy ? 'Adding…' : st.added ? 'Added to cart' : 'Add all to cart') + '</button>';
      if (missing.length) h += '<p class="cm-missing">Still needed: ' + esc(missing.join(', ')) + '.</p>';
      calc.problems.forEach(function (p) { h += '<p class="cm-missing">' + esc(p) + '</p>'; });
      h += '<p class="cm-note">Ball Insert 4-packs are one size each. If your chair\u2019s front and back legs are different sizes, one pack of each size covers 2 chairs.</p>';
      return h;
    }
    function tab(v, label) {
      var on = st.path === v;
      return '<button type="button" class="cm-tab' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="path" data-v="' + v + '">' + label + '</button>';
    }
    function chairHTML() {
      var h = '<label class="cm-label" for="' + uid + '-q">Chair name or SKU</label>' +
        '<input id="' + uid + '-q" class="cm-input" type="search" autocomplete="off" placeholder="e.g. CCRB-STEEL-AX-T or cross back" value="' + esc(st.query) + '" data-cm-focus="q" data-input="q">';
      h += '<div class="cm-results" aria-live="polite">';
      if (st.searching) h += '<p class="cm-muted">Searching…</p>';
      else if (st.searchMsg) h += '<p class="cm-muted">' + esc(st.searchMsg) + '</p>';
      st.results.forEach(function (r, i) {
        var on = st.sel && st.sel.handle === r.handle;
        h += '<button type="button" class="cm-result' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-act="pick" data-i="' + i + '">' +
          (r.image ? '<img src="' + esc(r.image) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="cm-result__ph"></span>') +
          '<span class="cm-result__txt"><strong>' + esc(r.title) + '</strong><small>SKU: ' + esc(r.skus.join(', ')) + '</small></span>' +
          (r.verified ? '<span class="cm-badge is-ok">Front ' + r.front + ' mm · Back ' + r.back + ' mm</span>' : '<span class="cm-badge">Sizes not verified</span>') + '</button>';
      });
      h += '</div>';
      if (st.sel && !st.sel.verified) h += '<p class="cm-warn">We haven\u2019t verified Ball Insert sizes for this chair yet. If you know your leg sizes, choose <strong>I know my sizes</strong>. Otherwise, the Fitment Pack lets you test the sizes on your chairs first.</p>';
      return h;
    }
    function manualHTML() {
      function sel(key, label, val) {
        var o = '<option value="">Choose a size</option>';
        SIZES.forEach(function (z) { o += '<option value="' + z + '"' + (String(z) === String(val) ? ' selected' : '') + '>' + z + ' mm</option>'; });
        return '<label class="cm-label">' + label + '<select class="cm-input" data-input="' + key + '">' + o + '</select></label>';
      }
      var h = '<div class="cm-grid2">' + sel('mf', 'Front legs', st.mf) + sel('mb', 'Back legs', st.mb) + '</div>';
      if (cfg.measureUrl) h += '<a class="cm-link" href="' + esc(cfg.measureUrl) + '">How to measure your chair legs</a>';
      h += '<label class="cm-confirm"><input type="checkbox" data-input="sure"' + (st.sure ? ' checked' : '') + '><span>I\u2019m confident these are the right sizes for my chairs. I understand Chivari hasn\u2019t verified them.</span></label>';
      return h;
    }
    function fitmentHTML() {
      var fp = cfg.fitment;
      var h = '<section class="cm-card cm-fitment"><h3 class="cm-h">ChairMates Fitment Pack</h3>' +
        '<p>Test the Ball Insert sizes on your own chair legs. When you\u2019ve found the snug fit, order your Chair Shoes and Ball Inserts with confidence.</p>';
      if (fp && fp.ok) {
        h += '<p class="cm-total"><span>Fitment Pack</span><span>' + esc(money(fp.price, cfg.moneyFormat)) + '</span></p>';
        h += '<button type="button" class="cm-atc" data-act="add-fitment"' + (!fp.available || st.busy ? ' disabled' : '') + '>' + (fp.available ? (st.busy ? 'Adding…' : st.added ? 'Added to cart' : 'Add Fitment Pack to cart') : 'Fitment Pack sold out') + '</button>';
        if (fp.url && fp.url !== cfg.currentUrl) h += '<a class="cm-link" href="' + esc(fp.url) + '">More about the Fitment Pack</a>';
      } else h += '<p class="cm-muted">The Fitment Pack isn\u2019t available online yet. Please call us and we\u2019ll help you find your size.</p>';
      return h + '</section>';
    }
    function partsHTML() {
      var h = '<p>Replacing lost or worn pieces? Order Chair Shoes and Ball Inserts on their own. Every item is a 4-pack.</p>';
      h += '<section class="cm-card"><h3 class="cm-h">Chair Shoes <span class="cm-h__val">· 4-packs by color</span></h3><div class="cm-rows">';
      cfg.shoes.forEach(function (s) { if (s.ok) h += partRow('pshoe', s.key, '<span class="cm-swatch__chip cm-swatch__chip--sm" style="background:' + esc(s.hex) + '"></span>' + esc(s.name), s, st.pShoe[s.key] || 0); });
      h += '</div></section><section class="cm-card"><h3 class="cm-h">Ball Inserts <span class="cm-h__val">· clear, 4-packs by size</span></h3><div class="cm-rows">';
      cfg.balls.forEach(function (b) { if (b.ok) h += partRow('pball', String(b.size), b.size + ' mm', b, st.pBall[b.size] || 0); });
      h += '</div>';
      if (cfg.fitment && cfg.fitment.ok && cfg.fitment.url) h += '<a class="cm-link" href="' + esc(cfg.fitment.url) + '">Not sure of your Ball Insert size? Get the Fitment Pack</a>';
      h += '</section>';
      var lines = partLines();
      h += summaryHTML(cfg, lines, lines.length ? '' : '<p class="cm-muted">Nothing selected yet.</p>');
      h += '<button type="button" class="cm-atc" data-act="add-parts"' + (!lines.length || st.busy ? ' disabled aria-disabled="true"' : '') + '>' + (st.busy ? 'Adding…' : st.added ? 'Added to cart' : 'Add to cart') + '</button>';
      if (!lines.length) h += '<p class="cm-missing">Add at least one 4-pack to continue.</p>';
      return h;
    }
    function partRow(act, key, label, p, n) {
      var dis = !p.available;
      return '<div class="cm-row' + (n ? ' is-on' : '') + '"><span class="cm-row__label">' + label + (dis ? ' <small>Sold out</small>' : '') + '</span>' +
        '<span class="cm-row__price">' + esc(money(p.price, cfg.moneyFormat)) + '</span>' +
        '<button type="button" class="cm-step cm-step--sm" data-act="' + act + '" data-k="' + esc(key) + '" data-d="-1" aria-label="Fewer"' + (n ? '' : ' disabled') + '>−</button>' +
        '<span class="cm-row__n" aria-live="polite">' + n + '</span>' +
        '<button type="button" class="cm-step cm-step--sm" data-act="' + act + '" data-k="' + esc(key) + '" data-d="1" aria-label="More"' + (dis ? ' disabled' : '') + '>+</button></div>';
    }
    function partLines() {
      var lines = [];
      cfg.shoes.forEach(function (s) { var n = st.pShoe[s.key]; if (n && s.ok) lines.push({ product: s, qty: n, name: 'Chair Shoes · ' + s.name + ' · 4-pack' }); });
      cfg.balls.forEach(function (b) { var n = st.pBall[b.size]; if (n && b.ok) lines.push({ product: b, qty: n, name: 'Ball Inserts · ' + b.size + ' mm · 4-pack' }); });
      return lines;
    }

    function search(q) {
      var my = ++seq;
      q = q.trim();
      if (q.length < 3) { st.results = []; st.searching = false; st.searchMsg = q ? 'Type at least 3 characters.' : ''; render(); return; }
      st.searching = true; st.searchMsg = ''; render();
      function suggest(term) {
        var u = cfg.routes.root + 'search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,variants.sku';
        return fetch(u, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
          var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          return ps.filter(function (p) { var t = p.type || ''; return /chair|stool/i.test(t) && !/cushion|cover|cap|part/i.test(t); });
        });
      }
      suggest(q).then(function (ps) {
        if (!ps.length && /-/.test(q) && q.charAt(0) !== '"') return suggest('"' + q + '"');
        return ps;
      }).then(function (ps) {
        ps = ps.slice(0, 6);
        return Promise.all(ps.map(function (p) {
          // no "Accept: application/json" here: with it, Shopify returns its own product JSON instead of our cmfit view
          return fetch(cfg.routes.root + 'products/' + encodeURIComponent(p.handle) + '?view=cmfit', { credentials: 'same-origin' })
            .then(function (r) { return r.text(); }).then(function (t) {
              var j = JSON.parse(t);
              return j && j.handle && Array.isArray(j.skus) ? j : null; // only accept our lookup's shape
            })
            .catch(function () { return null; });
        }));
      }).then(function (rows) {
        if (my !== seq) return;
        var qU = q.replace(/^"|"$/g, '').toUpperCase();
        var res = rows.filter(Boolean).map(function (r) {
          var f = validSize(r.front), b = validSize(r.back);
          var skus = (r.skus || []).filter(Boolean);
          return { handle: r.handle, title: r.title, image: r.image, skus: skus, front: f, back: b, verified: f != null && b != null,
            exact: skus.some(function (s) { return String(s).toUpperCase() === qU; }) };
        });
        res.sort(function (a, b) { return (b.exact - a.exact); });
        st.results = res; st.searching = false;
        st.searchMsg = res.length ? '' : 'No chairs found for \u201c' + q + '\u201d. Check the SKU, or choose \u201cI know my sizes\u201d or \u201cNot sure\u201d.';
        var ex = res.filter(function (r) { return r.exact; });
        if (ex.length === 1) st.sel = ex[0];
        else if (st.sel && !res.some(function (r) { return r.handle === st.sel.handle; })) st.sel = null;
        render();
      }).catch(function () {
        if (my !== seq) return;
        st.searching = false; st.results = []; st.searchMsg = 'Search isn\u2019t responding right now. Please try again.'; render();
      });
    }

    function doAdd(items) {
      if (!items.length) return;
      st.busy = true; st.err = ''; render();
      addToCart(cfg, items).then(function () { st.busy = false; st.added = true; render(); openCartDrawer(cfg); setTimeout(function () { st.added = false; render(); }, 2200); })
        .catch(function (e) { st.busy = false; st.err = e.message || 'Could not add to cart.'; render(); });
    }

    ui.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b || b.disabled || !ui.contains(b)) return;
      var act = b.getAttribute('data-act'), v = b.getAttribute('data-v');
      st.err = '';
      if (act === 'mode') st.mode = v;
      else if (act === 'path') st.path = v;
      else if (act === 'pick') st.sel = st.results[+b.getAttribute('data-i')] || null;
      else if (act === 'color') st.color = v;
      else if (act === 'qty') st.qty = Math.max(0, (st.qty || 0) + (+b.getAttribute('data-d')));
      else if (act === 'pshoe') { var k = b.getAttribute('data-k'); st.pShoe[k] = Math.max(0, (st.pShoe[k] || 0) + (+b.getAttribute('data-d'))); }
      else if (act === 'pball') { var z = b.getAttribute('data-k'); st.pBall[z] = Math.max(0, (st.pBall[z] || 0) + (+b.getAttribute('data-d'))); }
      else if (act === 'add-fitment') { if (cfg.fitment && cfg.fitment.id) doAdd([{ id: cfg.fitment.id, quantity: 1 }]); return; }
      else if (act === 'add-parts') { doAdd(itemsFrom(partLines())); return; }
      else if (act === 'add-set') {
        var f = fit(); if (!f || !st.color || !st.qty) return;
        var calc = setLines(cfg, f.front, f.back, st.color, st.qty); if (calc.problems.length) return;
        doAdd(itemsFrom(calc.lines)); return;
      }
      render();
    });
    ui.addEventListener('input', function (e) {
      var k = e.target.getAttribute('data-input'); if (!k) return;
      if (k === 'q') { st.query = e.target.value; clearTimeout(timer); timer = setTimeout(function () { search(st.query); }, 350); }
      else if (k === 'qty') { var n = parseInt(e.target.value, 10); st.qty = n > 0 ? n : 0; render(); }
    });
    ui.addEventListener('change', function (e) {
      var k = e.target.getAttribute('data-input'); if (!k) return;
      if (k === 'mf') st.mf = e.target.value; else if (k === 'mb') st.mb = e.target.value; else if (k === 'sure') st.sure = e.target.checked; else return;
      render();
    });
    render();
  }

  /* ---------------- Shoe Fit panel (chair product pages) ---------------- */
  function mountShoeFit(root) {
    var cfg = readData(root); if (!cfg) return;
    var ui = root.querySelector('[data-cm-ui]'); var uid = 'cmsf' + Math.random().toString(36).slice(2, 7);
    var front = validSize(cfg.chair.front), back = validSize(cfg.chair.back);
    var bf = ballFor(cfg, front), bb = ballFor(cfg, back);
    var anyShoe = cfg.shoes.some(function (s) { return s.ok; });
    if (front == null || back == null || !anyShoe || !bf || !bb || !bf.ok || !bb.ok) { root.hidden = true; return; }
    var st = { color: null, qty: 0, busy: false, added: false, err: '', open: false };
    var chev = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    function render() { keepFocus(root, function () { ui.innerHTML = html(); }); }
    function html() {
      var calc = setLines(cfg, front, back, st.color, st.qty);
      var lines = calc.lines.slice();
      if (!st.color) lines.unshift({ product: null, qty: 0, name: 'Chair Shoes · choose a color · 4-pack', note: '1 pack per chair' });
      var missing = []; if (!st.color) missing.push('a Chair Shoe color'); if (!st.qty) missing.push('how many chairs');
      var locked = missing.length > 0 || calc.problems.length > 0 || st.busy;
      var h = '<div class="cm-sf__head">' + (cfg.image ? '<img src="' + esc(cfg.image) + '" alt="" width="44" height="44" loading="lazy">' : '') +
        '<div><h3 class="cm-h">ChairMates Shoe Fit</h3><p class="cm-muted">Using these chairs on grass or sand? ChairMates stop the legs sinking.</p></div></div>';
      h += '<p class="cm-sf__label">Verified fit for this chair</p>';
      // everything below the label is collapsed into a faded teaser until the customer opens it
      h += '<div class="cm-sf__tease"><div class="cm-sf__body' + (st.open ? ' is-open' : '') + '" id="' + uid + '-body"' + (st.open ? '' : ' inert') + '>';
      h += '<p class="cm-sf__sizes">Front ' + front + ' mm · Back ' + back + ' mm</p>';
      var shoe = st.color ? byKey(cfg.shoes, 'key', st.color) : null;
      h += '<p class="cm-label">Chair Shoe color' + (shoe ? ': ' + esc(shoe.name) : '') + '</p>' + swatchesHTML(cfg, st.color, 'color');
      h += '<p class="cm-label">How many chairs?</p>' + qtyHTML(st.qty, uid + '-qty');
      h += summaryHTML(cfg, lines, '');
      h += '<button type="button" class="cm-atc cm-atc--accent" data-act="add"' + (locked ? ' disabled aria-disabled="true"' : '') + '>' + (st.busy ? 'Adding…' : st.added ? 'Added to cart' : 'Add ChairMates to cart') + '</button>';
      if (missing.length) h += '<p class="cm-missing">Still needed: ' + esc(missing.join(', ')) + '.</p>';
      calc.problems.forEach(function (p) { h += '<p class="cm-missing">' + esc(p) + '</p>'; });
      if (st.err) h += '<p class="cm-error" role="alert">' + esc(st.err) + '</p>';
      if (cfg.learnUrl) h += '<a class="cm-link" href="' + esc(cfg.learnUrl) + '">How ChairMates work</a>';
      h += '</div>';
      if (!st.open) h += '<button type="button" class="cm-sf__veil" data-act="toggle" tabindex="-1" aria-hidden="true"></button>';
      h += '</div>';
      if (!st.open) {
        h += '<button type="button" class="cm-sf__toggle" data-act="toggle" aria-expanded="false" aria-controls="' + uid + '-body">See ChairMates for this chair ' + chev + '</button>';
      } else {
        h += '<button type="button" class="cm-sf__hide" data-act="toggle" aria-expanded="true" aria-controls="' + uid + '-body">Hide ChairMates options</button>';
      }
      return h;
    }
    ui.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b || b.disabled || !ui.contains(b)) return;
      var act = b.getAttribute('data-act'); st.err = '';
      if (act === 'toggle') {
        st.open = !st.open; render();
        var f = st.open ? ui.querySelector('.cm-sf__body .cm-swatch:not([disabled])') : ui.querySelector('.cm-sf__toggle');
        if (f) f.focus();
        return;
      }
      if (act === 'color') st.color = b.getAttribute('data-v');
      else if (act === 'qty') st.qty = Math.max(0, (st.qty || 0) + (+b.getAttribute('data-d')));
      else if (act === 'add') {
        var calc = setLines(cfg, front, back, st.color, st.qty); if (!st.color || !st.qty || calc.problems.length) return;
        st.busy = true; render();
        addToCart(cfg, itemsFrom(calc.lines))
          .then(function () { st.busy = false; st.added = true; render(); openCartDrawer(cfg); setTimeout(function () { st.added = false; render(); }, 2200); })
          .catch(function (err) { st.busy = false; st.err = err.message || 'Could not add to cart.'; render(); });
        return;
      }
      render();
    });
    ui.addEventListener('input', function (e) {
      if (e.target.getAttribute('data-input') !== 'qty') return;
      var n = parseInt(e.target.value, 10); st.qty = n > 0 ? n : 0; render();
    });
    root.hidden = false;
    render();
  }

  function mountAll() {
    document.querySelectorAll('[data-cm-mount]:not([data-cm-ready])').forEach(function (el) {
      el.setAttribute('data-cm-ready', '');
      var kind = el.getAttribute('data-cm-mount');
      try { if (kind === 'fit-finder') mountFitFinder(el); else if (kind === 'shoe-fit') mountShoeFit(el); }
      catch (e) { if (window.console) console.error('ChairMates:', e); }
    });
  }
  window.ChairMates = { mountAll: mountAll, _validSize: validSize, _money: money, _setLines: setLines };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
})();